export default "__VITE_ASSET__7cf632fc__"